import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import avtar4 from '../../assets/images/user/avatar-4.jpg'
import { useProfile } from '../Context/ProfileContext';
import { imgUrl, putData } from '../Services/api';
import { toast } from 'react-toastify';
import ChangePassword from './ChangePassword';

const Profile = () => {
    const { profile, setProfile, fetchProfile } = useProfile();
    const [isLoading, setIsLoading] = useState(false);
    console.log(profile)
    const handleChange = (e) => {
        const { name, value } = e.target;
        setProfile({ ...profile, [name]: value })
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setProfile((prev) => ({
            ...prev,
            profileImage: file
        }))
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            setIsLoading(true)
            const formData = new FormData();
            formData.append('fullName', profile.fullName)
            formData.append('mobile', profile.mobile)
            formData.append('email', profile.email)
            formData.append('gender', profile.gender)
            formData.append('dob', profile.dob)
            formData.append('profileImage', profile.profileImage)
            const res = await putData('/auth/profile-update', formData);
            if (res.status) {
                toast.success(res.message);
                fetchProfile();
            }
        } catch (error) {
            console.log("error Profile update", error)
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link t0="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/users/user-list">Users</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            Account Profile
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">Account Profile</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body py-0">
                                    <ul className="nav nav-tabs profile-tabs" id="myTab" role="tablist">
                                        <li className="nav-item">
                                            <a
                                                className="nav-link active"
                                                id="profile-tab-2"
                                                data-bs-toggle="tab"
                                                href="#profile-2"
                                                role="tab"
                                                aria-selected="true"
                                            >
                                                <i className="fas fa-file-text me-2" />
                                                Personal Details
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className="nav-link"
                                                id="profile-tab-4"
                                                data-bs-toggle="tab"
                                                href="#profile-4"
                                                role="tab"
                                                aria-selected="true"
                                            >
                                                <i className="fas fa-lock me-2" />
                                                Change Password
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane show active"
                                    id="profile-2"
                                    role="tabpanel"
                                    aria-labelledby="profile-tab-2"
                                >
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h5>Personal Information</h5>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-sm-12 text-center mb-3">
                                                                <div className="user-upload wid-75">
                                                                    <img
                                                                        src={
                                                                            profile.profileImage
                                                                                ? typeof profile.profileImage === 'string'
                                                                                    ? `${profile.profileImage}`
                                                                                    : URL.createObjectURL(profile.profileImage)
                                                                                : avtar4
                                                                        }
                                                                        alt="img"
                                                                        className="img-fluid"
                                                                    />
                                                                    <label htmlFor="uplfile" className="img-avtar-upload">
                                                                        <i className="fa fa-camera f-24 mb-1" />
                                                                        <span>Upload</span>
                                                                    </label>
                                                                    <input type="file" id="uplfile" className="d-none" onChange={handleImageChange} />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-group">
                                                                    <label className="form-label">Name</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name='fullName'
                                                                        value={profile.fullName}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12">
                                                                <div className="form-group">
                                                                    <label className="form-label">Dob.</label>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        name='dob'
                                                                        value={profile?.dob?.split('T')[0]}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h5>Contact Information</h5>
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <div className="form-group">
                                                                    <label className="form-label">Contact Phone</label>
                                                                    <input
                                                                        type="number"
                                                                        className="form-control"
                                                                        name='mobile'
                                                                        value={profile.mobile}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-group">
                                                                    <label className="form-label">
                                                                        Email <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="email"
                                                                        className="form-control"
                                                                        name='email'
                                                                        value={profile.email}
                                                                        onChange={handleChange}
                                                                        readOnly
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12">
                                                                <div className="form-group">
                                                                    <label className="form-label">Gender</label>
                                                                    <select className="form-control" name='gender' value={profile.gender} onChange={handleChange}>
                                                                        <option value="male">Male</option>
                                                                        <option value="female">Female</option>
                                                                        <option value="other">Other</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 text-end btn-page">
                                                <div className="btn btn-outline-secondary">Cancel</div>
                                                <button className="btn btn-primary" type="submit" disabled={isLoading}>
                                                    {isLoading ? 'Updating...' : 'Update Profile'}
                                                </button >
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div
                                    className="tab-pane"
                                    id="profile-4"
                                    role="tabpanel"
                                    aria-labelledby="profile-tab-4"
                                >
                                    <div className="card">
                                        <div className="card-header">
                                            <h5>Change Password</h5>
                                        </div>
                                        <ChangePassword />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Profile